import React from 'react'
import UserOtp from '../../Components/User/UserOtp'

function UserotpPage() {
  return (
    <div>
      <UserOtp/>
    </div>
  )
}

export default UserotpPage